import * as React from 'react';

const SvgFlagSolid = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			d="M5.5 4.656a.75.75 0 0 0-1.5 0v14.5a.75.75 0 1 0 1.5 0v-4.391l1.657-.35a6.45 6.45 0 0 1 4.271.573 7.95 7.95 0 0 0 5.965.524l2.078-.639a.75.75 0 0 0 .529-.717v-8.5a.75.75 0 0 0-.904-.734l-2.38.501a7.25 7.25 0 0 1-4.186-.363l-.502-.2a8.75 8.75 0 0 0-5.053-.439l-1.475.31z"
		/>
	</svg>
);
export default SvgFlagSolid;
